// import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navigation from '../components/Navigation';
// import Loader from '../components/Loader'; 
import Footer from '../components/Footer';
import { footerEn } from '../data/footer';
import { navigationTop, navigationButtom } from '../params';
import { Link } from 'react-router-dom';
import '../assets/scss/Funding.scss'
import ResearchTrainingInner from '../components/Compliance/ResearchTrainingInner';
import ResearchTrainingOverview from '../components/Compliance/ResearchTrainingOverview';
// import '../assets/scss/CoreLabsAboutUs.scss';
// import '../assets/scss/Articles.scss';
// import 'bootstrap/dist/css/bootstrap.min.css'; 





const navigationIntern = []

const crumb = [
  // { link: '//', text: 'Home' },
  { link: '//', text: 'Home' },
  { link: '/', text: 'Research' },
  { link: '/research/research-training', text: 'Research Training' },
]

function ResearchTraining(props) {
  document.title = 'Research Training'
  const poster = '/uploads/core-labs.png'
  //const src = '/uploads/welcome.mp4'
  const headerData = {
    title: 'Research Training',
    crumb: crumb,
    navigationButtom: navigationButtom,
    navigationTop: navigationTop,
    applicationLinks: [{ text: 'Apply now', class: 'bordred', link: '/header/applynow' }],
  }



  return (
    <>
      <Navigation
        navigationIntern={navigationIntern}
        {...headerData}
        updateLang={props.updateLang}
      />
      <section class="m-wrap"><div class="container"><div><h2 class="text-hbku-primary p-b-2">Research Training at Hamad Bin Khalifa University</h2>
        <p>Hamad Bin Khalifa University’s Research Training provides a university-wide framework that supports the continuous development of research skills and professional capabilities across the research lifecycle. It reflects HBKU’s commitment to research excellence, integrity, and impact, and aligns with international standards and best practices.</p>

        <p>The Research Training ecosystem brings together cohort-based research development programs, online learning resources, in-person workshops, and research compliance education to ensure accessible, high-quality development opportunities for the HBKU research community.
        </p>
      </div>
      </div>
      </section>
      <section class="mb-5">
        <div class="container">
          <h2 class="text-hbku-primary p-b-2">Purpose and Value</h2>
          <div class="l-article">
            <ul class="m-b-0">
              <li class="p-b-1">Strengthen institutional research capacity across colleges and research institutes.</li>
              <li class="p-b-1">Provide flexible access to online resources and structured training opportunities.</li>
              <li class="p-b-1">Support skills development through targeted, expert-led workshops.</li>
              <li class="p-b-1">Promote responsible, ethical, and transparent research practices.</li>
              <li class="p-b-1">Foster continuous learning and professional growth across the research community.</li>
            </ul>
          </div>
        </div>
      </section>

      <section class="mb-5">
        <div class="container">
          <h2 class="text-hbku-primary p-b-2">Research Training Components</h2>
          <div class="l-article">
            <ul class="m-b-0">
              <li class="p-b-1">Cohort-based research development programs that foster peer learning.</li>
              <li class="p-b-1">Curated online resources supporting self-paced and continuous learning.</li>
              <li class="p-b-1">Expert-led, interactive in-person workshops focused on research design, scholarly writing, communication, leadership, and professional development.</li>
              <li class="p-b-1">Guidance that promotes research quality, integrity, compliance, and impact.</li>
            </ul>
          </div>
        </div>
      </section>


      {/* <section class="mb-5 pb-4"> 
        <div class="container">
       
          <div class="funding-news-info">
            <div className="dieBlock7__block">
          
              <div className="dieBlock7__block__list ">
                <a href="/research/online-training"  rel="noreferrer">
                  <div className="dieBlock7--image">
                    <figure className="">
                      <img width="100%" height="296" src="https://www.hbku.edu.qa/sites/default/files/banner-include.png"
                        alt="" className="full-width img-responsive" />
                      <figcaption> Online Training</figcaption>
                    </figure>
                  </div>
                  <div className="dieBlock7__content-info bg-grey-bx">
                    <div className="dieBlock7--header p-b-0 m-b-0"> Online Training</div>
                  </div>
                </a>
              </div>

    <div className="dieBlock7__block__list ">
                <a href="/research/ecrd"  rel="noreferrer">
                  <div className="dieBlock7--image">
                    <figure className="">
                      <img width="100%" height="296" src="https://www.hbku.edu.qa/sites/default/files/shutterstock_1926463520-3.jpg"
                        alt="" className="full-width img-responsive" />
                      <figcaption>Training Program & Workshops</figcaption>
                    </figure>
                  </div>
                  <div className="dieBlock7__content-info">
                    <div className="dieBlock7--header p-b-0 m-b-0">Training Program & Workshops</div>
                  </div>
                </a>
              </div>

              <div className="dieBlock7__block__list ">
                <a href="/research/ecrd"  rel="noreferrer">
                  <div className="dieBlock7--image">
                    <figure className="">
                      <img width="100%" height="296" src="https://www.hbku.edu.qa/sites/default/files/shutterstock_1926463520-3.jpg"
                        alt="" className="full-width img-responsive" />
                      <figcaption>Training Program & Workshops</figcaption>
                    </figure>
                  </div>
                  <div className="dieBlock7__content-info">
                    <div className="dieBlock7--header p-b-0 m-b-0">Training Program & Workshops</div>
                  </div>
                </a>
              </div>


            </div>
          </div>

        </div>
      </section> */}
<section className="mb-5 pb-4">
  <div className="container">
    <div className="funding-news-info">
      
      <div className="row">
        
        <div className="col-lg-4 mb-4 mb-lg-0">
          <div className="dieBlock7__block__list w-100 m-0 radius-6 overflow-hidden">
            <a href="/research/online-training" rel="noreferrer">
              <div className="dieBlock7--image">
                <figure className='no-overlay'>
                  <img
                    width="100%"
                    height="255"
                    src="https://www.hbku.edu.qa/sites/default/files/banner-include.png"
                    alt="Online Training"
                    className="full-width img-responsive"
                  />
                  <span className="badge bg-blue-primary">Online Resources</span>
                 
                </figure>
              </div>
              <div className="dieBlock7__content-info bg-grey-bx">
                <div className="dieBlock7--header p-b-0 m-b-0 fs-20">
                  Nature Masterclass
                </div>
              </div>
            </a>
          </div>
        </div>

        <div className="col-lg-4 mb-4 mb-lg-0">
          <div className="dieBlock7__block__list w-100 m-0 radius-6 overflow-hidden">
            <a href="/research/citi" rel="noreferrer">
              <div className="dieBlock7--image">
                <figure className='no-overlay'>
                  <img
                    width="100%"
                    height="255"
                    src="https://www.hbku.edu.qa/sites/default/files/citi-research-training.jpg"
                    alt="citi research training"
                    className="full-width img-responsive"
                  />
                  <span className="badge bg-blue-primary">Online Resources</span>
                </figure>
              </div>
              <div className="dieBlock7__content-info bg-grey-bx">
                <div className="dieBlock7--header p-b-0 m-b-0 fs-20">
                  CITI
                </div>
              </div>
            </a>
          </div>
        </div>

        <div className="col-lg-4 mb-4 mb-lg-0">
          <div className="dieBlock7__block__list w-100 m-0 radius-6 overflow-hidden">
            <a href="/research/ecrd" rel="noreferrer">
              <div className="dieBlock7--image">
                <figure className='no-overlay'>
                  <img
                    width="100%"
                    height="255"
                    src="https://www.hbku.edu.qa/sites/default/files/ECRD%20Banner_0.jpg"
                    alt="Training Program & Workshops"
                    className="full-width img-responsive"
                  />
                 
                </figure>
              </div>
              <div className="dieBlock7__content-info bg-grey-bx">
                <div className="dieBlock7--header p-b-0 m-b-0 fs-20">
                  Training Program & Workshops
                </div>
              </div>
            </a>
          </div>
        </div>

      </div>

    </div>
  </div>
</section>

      <Footer {...footerEn} />
    </>
  )
}

export default ResearchTraining;
